/**
 * @packageDocumentation
 * @module Auth
 * @category Core
 */

import { Injectable } from '@angular/core';

/**
 * Сервис для работы с идентификатором устройства.
 *
 * @group Services
 */
@Injectable({ providedIn: 'root' })
export class AuthDeviceService {
  protected storageKey = 'deviceId';

  /**
   * Получить или сгенерировать идентификатор устройства.
   * Ранее сгенерированный идентификатор хранится в localStorage.
   *
   * @returns Уникальный идентификатор устройства
   */
  public getOrGenerate(): string {
    let deviceId = this.get();

    if (!deviceId) {
      deviceId = this.generateDeviceId();
      this.set(deviceId);
    }

    return deviceId;
  }

  /**
   * Получить ранее сохраненный идентификатор устройства.
   *
   * @returns Уникальный идентификатор устройства или null, если не найден
   */
  public get(): string | null {
    return localStorage.getItem(this.storageKey) || null;
  }

  /**
   * Сохранить идентификатор устройства.
   *
   * @param deviceId Идентификатор устройства
   */
  public set(deviceId: string): void {
    localStorage.setItem(this.storageKey, deviceId);
  }

  protected generateDeviceId(): string {
    const length = 40;
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

    let text = '';

    for (let i = 0; i < length; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return text;
  }
}
